import DateRangePicker from "@/components/DateRangePicker";
import DebouncedInput from "@/components/DebouncedInput";
import SelectFilter from "@/components/SelectFilter";
import { Box } from "@chakra-ui/react";
import { Dispatch, SetStateAction, useCallback } from "react";
import { FiltersType } from "../types/filters.type";

type Props = {
  queryFilters: FiltersType;
  setQueryFilters: Dispatch<SetStateAction<FiltersType>>;
};

const mapStatus: Record<string, string> = {
  Pendiente: "pending",
  Enviado: "sent",
  Error: "failed",
};

export const Filters = ({ queryFilters, setQueryFilters }: Props) => {
  const handleSearchByDocumentNumber = useCallback(
    (value: string) =>
      setQueryFilters((prev) => ({ ...prev, customerDocumentNumber: value })),
    [setQueryFilters]
  );

  const handleSearchByInvoiceId = useCallback(
    (value: string) =>
      setQueryFilters((prev) => ({ ...prev, invoiceId: value })),
    [setQueryFilters]
  );

  const handleSearchBySendDates = (dates: [string, string] | undefined) => {
    setQueryFilters((prev) => ({ ...prev, sendDates: dates }));
  };

  const handleSearchByStatus = useCallback(
    (value: string | undefined) =>
      setQueryFilters((prev) => ({ ...prev, status: value })),
    [setQueryFilters]
  );

  return (
    <Box display="flex" gap={"1rem"} minWidth={"50rem"}>
      <DebouncedInput
        size="sm"
        placeholder="Cédula"
        value={queryFilters.customerDocumentNumber}
        onDebouncedChange={handleSearchByDocumentNumber}
      />
      <DebouncedInput
        size="sm"
        placeholder="ID de la factura"
        value={queryFilters.invoiceId}
        onDebouncedChange={handleSearchByInvoiceId}
      />
      <DateRangePicker
        placeholder="Rango de fechas"
        values={queryFilters.sendDates}
        setValues={handleSearchBySendDates}
        maxDate={new Date()}
      />
      <SelectFilter
        isClearable
        options={Object.keys(mapStatus)}
        selectedOption={queryFilters.status}
        onSelect={handleSearchByStatus}
        placeholder="Estado"
        width="100%"
      />
    </Box>
  );
};
